<template>
  <div class="logo-full-signature-centralized-content">
    <div class="description-full-signature-centralized-wrapper">
      <div class="logo-full-signature-centralized-icon-wrapper">
        <p class="logo-full-signature-centralized-title" >
          {{ logoFullSignatureDescription15 }}
        </p>
      </div>
    </div>
    <div
      class="logo-full-signature-centralized-card-item"
      :style="{ backgroundImage: `url(${logoFullSignatureImageSrc9})` }"
    ></div>    
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LogoSignatureCentralizedSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoFullSignatureDescription15(): string {
    return this.getElementText(15, 18)
  }

  get logoFullSignatureImageSrc9(): string {
    return this.getElementMedia(15, 19)
  }
  
  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-full-signature-centralized-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.description-full-signature-centralized-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-full-signature-centralized-title {
  font-size: 30px;
  font-weight: 300;
  line-height: 20px;
  text-align: left;
  
  width: 100%;  
}

.logo-full-signature-centralized-icon-wrapper {
  display: flex;
  align-items: center;
}

.logo-full-signature-card-item {
  position: relative;
  bottom: 0;
  width: 100%;
  max-width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-full-signature-centralized-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  border-radius: 20px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-full-signature-centralized-card-item-1 {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 531px;

  border-radius: 20px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
